import { Spinner } from './spinner';

export const SpinnerOverlay = ({
  spinneClassName,
}: {
  spinneClassName?: string;
}) => {
  return (
    <div className='pointer-events-none absolute z-50 h-full w-full bg-[hsl(var(--accent))] opacity-60'>
      <Spinner color='hsl(var(--primary))' className={spinneClassName} />
    </div>
  );
};
